import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  ar: { translation: ar }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // FR par défaut pour l'app O'SCOP Outremer (audience francophone DOM-TOM).
    // L'utilisateur peut changer via le sélecteur (drapeau) ; le choix est
    // persisté dans localStorage.
    lng: undefined,           // laisse le detector décider
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'ar'],
    nonExplicitSupportedLngs: false,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      // On NE détecte PAS via navigator.language : sinon un browser
      // configuré en anglais ferait apparaître l'UI en EN alors que
      // l'app est francophone par défaut. Seul localStorage compte
      // (alimenté par le sélecteur de langue dans l'UI).
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
